import React, { Component } from "react";
import "./OptSearch.css";
import $ from "jquery";

export default class OptSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicId: "",
    };
  }

  submitOptForm = (needReload = false) => {
    let match = "{";
    var inputText = $("#search-text").val();

    const OptSearchUrl = window.location.pathname;
    let params = {};

    $("p.selected").text(inputText);
    $("p.selected").attr("data-value", inputText);

    let searchValue =
      $("td.search-row-text").find("p.selected").data("value") || "";
    if (searchValue) {
      params["search"] = searchValue;
    }

    let opusValue = $("#opus").val();
    if (opusValue && opusValue !== "null") {
      params["opus"] = opusValue;
    }

    $(".search-row")
      .not(".search-row-text")
      .each(function () {
        var title = $(this).children(".search-form__td-title").attr("value");
        var value = $(this).find("li.selected").attr("value");
        //console.log($(this).children(".search-form__td-title").attr("value"));
        //console.log("Title: " + title + ", Value: " + value);
        if (title && value) {
          params[title] = value;
          match += `"${title}":"${value}", `;
          sessionStorage.setItem(title, value);
        }
      });

    let queryString = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    //console.log("Query String: " + queryString);

    let newUrl = `${OptSearchUrl}?${queryString}`;
    window.history.pushState(null, "", newUrl);

    if (needReload) {
      //console.log("Reloading page with new parameters.");
      window.location.reload();
    }
  };

  // startType = (e) => {
  //     e.preventDefault();
  //     if (e.target.value !== "") {
  //         this.setState({
  //             dynamicId: "opusdata"
  //         })
  //     } else {
  //         this.setState({
  //             dynamicId: ""
  //         })
  //     }
  // }

  startType = (e) => {
    const inputText = e.target.value;
    this.setState({ dynamicId: inputText ? "opusdata" : "" });

    $("p.selected").text(inputText).attr("data-value", inputText);

    if (inputText) {
      sessionStorage.setItem("opus", inputText);
    }
  };

  clear = () => {
    sessionStorage.clear();
    window.location.reload();
  };

  componentDidMount() {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);

    sessionStorage.setItem("OptSearchUrl", currentPath);

    const searchText = String(urlParams.get("search"));
    const tonation = String(urlParams.get("id_tonation"));
    const cast = String(urlParams.get("id_cast"));
    const genere = String(urlParams.get("id_genere"));
    const opus = String(urlParams.get("opus"));
    const year = String(urlParams.get("id_year"));
    const addressee = String(urlParams.get("id_addressee"));

    let setReload = true;
    let optSearchObj = {};

    if (searchText) {
      sessionStorage.setItem("search", searchText);
      optSearchObj["search"] = searchText;
    }
    if (tonation) {
      sessionStorage.setItem("id_tonation", tonation);
      optSearchObj["id_tonation"] = tonation;
    }
    if (cast) {
      sessionStorage.setItem("id_cast", cast);
      optSearchObj["id_cast"] = cast;
    }
    if (genere) {
      sessionStorage.setItem("id_genere", genere);
      optSearchObj["id_genere"] = genere;
    }
    if (year) {
      sessionStorage.setItem("id_year", year);
      optSearchObj["id_year"] = year;
    }
    if (addressee) {
      sessionStorage.setItem("id_addressee", addressee);
      optSearchObj["id_addressee"] = addressee;
    }
    if (opus) {
      sessionStorage.setItem("opus", opus);
      optSearchObj["opus"] = opus;
    }

    sessionStorage.setItem("OptSearch", JSON.stringify(optSearchObj));

    this.loadFiltersFromSessionStorage();

    if (!sessionStorage.getItem("submitFormCalled") && setReload) {
      this.submitOptForm();
      sessionStorage.setItem("submitFormCalled", "true");
    } else {
      const storedTonation = sessionStorage.getItem("id_tonation");
      const storedCast = sessionStorage.getItem("id_cast");
      const storedGenere = sessionStorage.getItem("id_genere");
      const storedYear = sessionStorage.getItem("id_year");
      const storedAddressee = sessionStorage.getItem("id_addressee");
      const storedOpus = sessionStorage.getItem("opus");

      if (
        tonation === storedTonation &&
        cast === storedCast &&
        genere === storedGenere &&
        year === storedYear &&
        addressee === storedAddressee &&
        opus === storedOpus
      ) {
        setReload = false;
        sessionStorage.removeItem("submitFormCalled");
        console.log("Filtry są takie same, nie wymagają przeładowania.");
      }
    }

    if (opus === "null") {
      $("#opus").val("");
    } else {
      $("#opus").val(opus);
    }

    //console.log(tonation == sessionStorage.getItem('id_tonation'), cast == sessionStorage.getItem('id_cast'), genere == sessionStorage.getItem('id_genere'), year == sessionStorage.getItem('id_year'), opus == sessionStorage.getItem('opus'));
    //console.log(sessionStorage.getItem('id_year'), sessionStorage.getItem('id_genere'), sessionStorage.getItem('id_cast'), sessionStorage.getItem('id_tonation'), sessionStorage.getItem('opus'));
    //console.log(year, genere, cast, tonation, opus);
  }

  loadFiltersFromSessionStorage() {
    let searchText = sessionStorage.getItem("search");
    let tonation = sessionStorage.getItem("id_tonation");
    let cast = sessionStorage.getItem("id_cast");
    let genere = sessionStorage.getItem("id_genere");
    let year = sessionStorage.getItem("id_year");
    let addressee = sessionStorage.getItem("id_addressee");
    let opus = sessionStorage.getItem("opus");

    const urlParams = new URLSearchParams(window.location.search);
    const searchTextUrl = urlParams.get("search");
    const tonationUrl = urlParams.get("id_tonation");
    const castUrl = urlParams.get("id_cast");
    const yearUrl = urlParams.get("id_year");
    const genereUrl = urlParams.get("id_genere");
    const addresseeUrl = urlParams.get("id_addressee");

    if (searchText != null && searchText === searchTextUrl) {
      $("#search-text").val(searchText);
      $("p.selected").text(searchText);
      $("p.selected").attr("data-value", searchText);
    }

    if (tonation != null && tonation === tonationUrl) {
      $("#tonation li").removeClass("selected");
      $("#tonation li").each(function () {
        if ($(this).attr("value") === tonation) {
          $(this).addClass("selected");
        }
      });
    }

    if (cast != null && cast === castUrl) {
      $("#cast li").removeClass("selected");
      $("#cast li").each(function () {
        if ($(this).attr("value") === cast) {
          $(this).addClass("selected");
        }
      });
    }

    if (genere != null && genere === genereUrl) {
      $("#genere li").removeClass("selected");
      $("#genere li").each(function () {
        if ($(this).attr("value") === genere) {
          $(this).addClass("selected");
        }
      });
    }

    if (year != null && year === yearUrl) {
      $("#year li").removeClass("selected");
      $("#year li").each(function () {
        if ($(this).attr("value") === year) {
          $(this).addClass("selected");
        }
      });
    }

    if (addressee != null && addressee === addresseeUrl) {
      $("#addressee li").removeClass("selected");
      $("#addressee li").each(function () {
        if ($(this).attr("value") === addressee) {
          $(this).addClass("selected");
        }
      });
    }

    if (opus !== null) {
      $("#opus").val(opus);
    } else {
      $("#opus").val("");
    }
  }

  render() {
    document.addEventListener("keypress", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("search-engine-submit").click();
      }
    });

    $(function () {
      $(".select-container ul")
        .unbind()
        .click(function () {
          $(this).toggleClass("opened");
        });

      $("#optional-search-form ul li").click(function () {
        var match = "{";
        var inputText = $("#search-text").val();
        $("p.selected").text(inputText);
        $("p.selected").attr("value", inputText);

        if ($(this).hasClass("selected")) {
          // Nie rób nic, jeśli element już jest zaznaczony
        } else {
          $(this).addClass("selected").siblings().removeClass("selected");

          const parentId = $(this).parent("ul").attr("id");
          const itemValue = $(this).attr("value");
          sessionStorage.setItem(`id_${parentId}`, itemValue);

          // Aktualizuj pole opus, jeśli to dotyczy
          if (parentId === "opusdata") {
            // Upewnij się, że to jest poprawny id listy dla opus
            $("#opus").val(itemValue); // Ustaw wartość w polu input
            sessionStorage.setItem("opus", itemValue); // Zapisz do sessionStorage
          }

          $(".search-row").each(function () {
            var title = $(this)
              .children(".search-form__td-title")
              .attr("value");
            var value = $(this).find(".selected").attr("value");
            match += '"' + title + '":';
            match += '"' + value + '", ';
          });
        }
        match = match.slice(0, -2);
        match += "}";
        sessionStorage.setItem("OptSearch", match);
      });

      $("#search-text").on("input", function (e) {
        var inputText = $("#search-text").val();
        $("p.selected").text(inputText);
      });
    });

    $(document).mouseup(function (e) {
      var container = $(".select-container ul.opened");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("opened");
      }
    });

    // LABELS BASED ON LANGUAGE
    let search_label_1 =
      window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
    let search_label_2 =
      window.location.href.indexOf("/en/") > -1
        ? "Enter a search phrase"
        : "Wpisz szukaną frazę";
    let search_label_3 =
      window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
    let search_label_4 =
      window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
    let search_label_5 =
      window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

    return (
      <div className="optional-search-container">
        <form id="optional-search-form" className="OptSearch">
          <table>
            <tbody>
              <tr className="search-row">
                <td
                  colSpan={2}
                  className="search-row-text search-form__td-title"
                  value="search"
                >
                  <input
                    id="search-text"
                    type="text"
                    placeholder={search_label_2}
                    aria-label="search text"
                  />
                  <p className="selected" style={{ margin: 0 }}></p>
                </td>
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[0].field_name}
                  >
                    {this.props.filter_search[0].name}
                  </span>
                  <div className="select-container">
                    <ul id="tonation">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[0].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[1].field_name}
                  >
                    {this.props.filter_search[1].name}
                  </span>
                  <div className="select-container">
                    <ul id="genere">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[1].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[2].field_name}
                  >
                    {this.props.filter_search[2].name}
                  </span>
                  <div className="select-container">
                    <ul id="cast">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[2].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[3].field_name}
                  >
                    {this.props.filter_search[3].name}
                  </span>
                  <div className="select-container">
                    <ul id="year">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[3].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[4].field_name}
                  >
                    {this.props.filter_search[4].name}
                  </span>
                  <div className="select-container">
                    <input
                      onChange={this.startType}
                      id="opus"
                      list="opusdata"
                      type="text"
                      placeholder={search_label_5}
                      aria-label={search_label_5}
                    />
                    <datalist id={this.state.dynamicId}>
                      {this.props.filter_search[4].list.map(function (
                        item,
                        index
                      ) {
                        return (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </datalist>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[5].field_name}
                  >
                    {this.props.filter_search[5].name}
                  </span>
                  <div className="select-container">
                    <ul id="addressee">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[5].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="search-engine-options">
            <button onClick={this.clear}>{search_label_1}</button>
            <button
              id="search-engine-submit"
              className="submit"
              onClick={(e) => {
                e.preventDefault();
                this.submitOptForm(true);
              }}
            >
              {search_label_3}
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch/index.jsx